import { get } from './client.js';

export const listTimeline = (orgId, params = {}) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => { if (v) qs.set(k, String(v)); });
  const q = qs.toString();
  return get(`/orgs/${orgId}/timeline${q ? '?' + q : ''}`);
};
